import React from 'react';

const ProductShowcase = () => {
  const products = [
    {
      image: 'https://assets.storydoc.com/13c8efe3fa4882546678ec6b4c38fb70/af029fcf-8fdf-4ac4-9162-961e10e9dd3d.webp',
      alt: 'Luxury glass elevator cabin interior, modern premium design, elegant lighting, architectural detail',
      series: 'PRO SERIES',
      title: 'Quiet, intelligent and comfortable ride',
      description: 'Low standby power consumption, energy saving and environmental protection. Compact size, easy to install, improve space utilisation. Standard contactless technology, immersive enjoyment of silent elevator experience'
    },
    {
      image: 'https://assets.storydoc.com/13c8efe3fa4882546678ec6b4c38fb70/1c07fa94-1edc-4f88-9f08-378b6d7c7bb5.webp',
      alt: 'Compact home elevator, modern residential design, wood and metal finishes, luxury interior',
      series: 'PANORAMIC SERIES',
      title: 'Each floor presents a different view',
      description: 'Low standby power consumption, energy saving and environmental protection. Compact size, easy to install, improve space utilisation. Standard contactless technology, immersive enjoyment of silent elevator experience'
    },
    {
      image: 'https://assets.storydoc.com/13c8efe3fa4882546678ec6b4c38fb70/7454d717-30df-400f-9d10-25dbce20ca09.webp',
      alt: 'Commercial freight elevator, industrial design, heavy duty cargo lift, steel construction',
      series: 'MINI SERIES',
      title: 'The ultimate space offers infinite possibilities',
      description: 'Smaller main machine size. The adoption of low-power main machine, realising energy saving. The adoption of the floor plan section design makes the elevator operation more stable'
    },
    {
      image: 'https://assets.storydoc.com/13c8efe3fa4882546678ec6b4c38fb70/dd9dd189-709b-4e4b-ae23-030052c6e4f6.webp',
      alt: 'Curved stairlift on elegant staircase, premium accessibility solution, luxury home interior, modern design',
      series: 'CLASSIES SERIES',
      title: 'Modernization',
      description: 'Old elevators have problems such as high noise, poor performance, and poor safety due to backward structure, technology, and long service life. Modernization and renovation give a new experience to building traffic with lower cost, shorter'
    }
  ];

  return (
    <section className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-16">
          <div className="inline-block mb-4">
            <span className="text-premium-gold text-sm font-semibold tracking-widest uppercase">Product Lineup</span>
          </div>
          <h2 className="font-display text-5xl font-bold text-premium-dark mb-6">
            Premium Product Range
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Explore our comprehensive collection of lift systems, each engineered to perfection
          </p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 mb-12">
          {products.map((product, index) => (
            <div key={index} className="group bg-premium-light hover:shadow-xl transition-all duration-300">
              <div className="h-72 overflow-hidden">
                <img
                  src={product.image}
                  alt={product.alt}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="p-6">
                <div className="flex items-center justify-between mb-3">
                  <span className="text-xs font-semibold text-premium-gold tracking-widest">{product.series}</span>
                  <i className="fa-solid fa-arrow-right text-premium-gold opacity-0 group-hover:opacity-100 transition-opacity"></i>
                </div>
                <h3 className="hidden sm:block font-display text-xl font-bold text-premium-dark mb-2">
                  {product.title}
                </h3>
                <p className="hidden sm:block text-gray-600 text-sm mb-4">{product.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ProductShowcase;
